import { useOutletContext, useParams } from "react-router-dom";
import { StorefrontConfig } from "../../components/StorefrontConfig";
import type { StoreType } from "../../../repositories/storefrontRepository";
import type { ProjectContextData } from "./ProjectLayout";

function SectionHeader({ icon, title }: { icon: string; title: string }) {
  return (
    <div className="flex items-center gap-2 border-l-4 border-primary pl-3 mb-5">
      <span className="material-symbols-outlined text-primary">{icon}</span>
      <h3 className="text-xl font-bold">{title}</h3>
    </div>
  );
}

export function ProjectStorefrontsPage() {
  const { id } = useParams<{ id: string }>();
  const { project, storefronts, setStorefronts } = useOutletContext<ProjectContextData>();

  const handleSaveStorefront = async (
    store: StoreType,
    config: Record<string, unknown>,
    enabled: boolean,
    autoDeployOnBuild: boolean
  ) => {
    if (!id) return;

    const response = await fetch(`/api/projects/${id}/storefronts`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ store, config, enabled, autoDeployOnBuild }),
    });

    if (!response.ok) {
      throw new Error("Failed to save storefront configuration");
    }

    const { data: updatedStorefront } = await response.json();
    setStorefronts((prev) => {
      const filtered = prev.filter((s) => s.store !== store);
      return [...filtered, updatedStorefront];
    });
  };

  return (
    <div className="space-y-8">
      <section>
        <SectionHeader icon="storefront" title="Storefront Connections" />
        <div className="p-6 rounded-xl bg-card border border-border shadow-sm">
          <p className="text-muted-foreground text-sm mb-6">
            Connect your game to digital storefronts to automatically deploy builds when they complete successfully.
          </p>
          <StorefrontConfig
            projectId={project.id}
            storefronts={storefronts}
            onSave={handleSaveStorefront}
          />
        </div>
      </section>
    </div>
  );
}
